import { render, staticRenderFns } from "./specialdiet.vue?vue&type=template&id=2ed351f6&scoped=true"
import script from "./specialdiet.vue?vue&type=script&lang=js"
export * from "./specialdiet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed351f6",
  null
  
)

export default component.exports